import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import isEmpty from 'lodash/isEmpty';
import CompanyItem from './CompanyItem';
import RoleItem from './RoleItem';
import * as DateUtil from '../utils/dates';

/**
 * [Model] UserItem
 */
var UserItem = /*#__PURE__*/function () {
  function UserItem() {
    _classCallCheck(this, UserItem);
  }
  return _createClass(UserItem, null, [{
    key: "parseV1",
    value:
    /**
     * Parse snake case data
     */
    function parseV1(rowData) {
      var data = rowData || {};
      var entity = new UserItem();

      // Invite user will return a user with user_id
      entity.accessType = data.access_type;
      entity.analyticsId = data.analytics_id;
      entity.company = CompanyItem.parseV1(data.company);
      entity.email = data.email;
      entity.id = data.ea_user_id || data.user_id || data.id;
      entity.isProjectAdmin = data.is_project_admin;
      entity.name = data.name;
      entity.oxygenId = data.oxygen_id;
      entity.profileImg50 = data.profile_img_50;
      entity.projectStatus = data.project_status;
      entity.roles = data.roles ? data.roles.map(function (role) {
        return RoleItem.parseV1(role);
      }) : [];
      entity.status = data.status;
      return entity;
    }

    /**
     * Parse camel case data
     */
  }, {
    key: "parseV2",
    value: function parseV2(rowData) {
      var data = rowData || {};
      var entity = new UserItem();
      entity.company = CompanyItem.parseV2(data.company);
      entity.companyId = data.companyId;
      entity.companyName = data.companyName;
      entity.downloadedTime = DateUtil.dateStringReformat(data.downloadedTime);
      entity.email = data.email;
      entity.id = data.userId;
      entity.isIndividualSelected = data.isIndividualSelected;
      entity.name = data.name;
      entity.profileImg20 = data.profileImg20;
      entity.profileImg50 = data.profileImg50;
      entity.isIndividualSelected = data.isIndividualSelected;
      entity.company = CompanyItem.parseV2(data.company);
      entity.roles = (data.roles || []).map(RoleItem.parseV2);
      entity.receivedTime = isEmpty(data.receivedTime) ? data.receivedTime : DateUtil.dateStringReformat(data.receivedTime);
      entity.viewedTime = isEmpty(data.viewedTime) ? data.viewedTime : DateUtil.dateStringReformat(data.viewedTime);
      entity.downloadedTime = isEmpty(data.downloadedTime) ? data.downloadedTime : DateUtil.dateStringReformat(data.downloadedTime);
      entity.companyId = data.companyId;
      entity.companyName = data.companyName;
      return entity;
    }

    /**
     * Parse HQ case data
     */
  }, {
    key: "parseHQ",
    value: function parseHQ(rowData) {
      var data = rowData || {};
      var entity = new UserItem();
      entity.analyticsId = data.analyticsId;
      entity.company = CompanyItem.parseHQ(data.companyId ? {
        id: data.companyId
      } : {});
      entity.email = data.email;
      entity.id = data.id;
      entity.isAccountAdmin = data.accessLevels && data.accessLevels.accountAdmin === true;
      entity.isExecutive = data.accessLevels && data.accessLevels.executive === true;
      entity.isProjectAdmin = data.accessLevels && data.accessLevels.projectAdmin === true;
      entity.name = data.name;
      entity.oxygenId = data.autodeskId;
      entity.profileImg50 = data.imageUrl;
      entity.roles = data.roleIds ? data.roleIds.map(function (id) {
        return {
          id: id
        };
      }) : [];
      entity.services = data.services;
      entity.status = data.status;
      return entity;
    }

    /**
     * Parse admin case data for Construction product (ACC)
     */
  }, {
    key: "parseAdmin",
    value: function parseAdmin(rowData) {
      var data = rowData || {};
      var entity = new UserItem();
      entity.analyticsId = data.analyticsId;
      entity.company = CompanyItem.parseHQ(data.companyId ? {
        id: data.companyId,
        name: data.companyName
      } : {});
      entity.email = data.email;
      entity.id = data.id;
      entity.isAccountAdmin = data.accessLevels && data.accessLevels.accountAdmin === true;
      entity.isExecutive = data.accessLevels && data.accessLevels.executive === true;
      entity.isProjectAdmin = data.accessLevels && data.accessLevels.projectAdmin === true;
      entity.name = data.name;
      entity.oxygenId = data.autodeskId;
      entity.profileImg50 = data.imageUrl;
      entity.roles = data.roles || [];
      entity.status = data.status;
      // Reusing the `status` field to match Docs V1 API format to avoid breaking change.
      // Generally, the `projectStatus` should have same value with `status` field now.
      // https://autodesk.slack.com/archives/C54JF4ATU/p1698735186610129
      entity.projectStatus = data.status;
      // Construction admin response with the shape of [{ key, access: 'administrator', 'member' or 'none' }]
      entity.products = data.products;
      return entity;
    }
  }]);
}();
export { UserItem as default };